var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 29.75C28.3332 27.7729 28.3332 26.7844 28.0892 25.98C27.5398 24.169 26.1225 22.7517 24.3115 22.2023C23.5071 21.9583 22.5186 21.9583 20.5415 21.9583H13.4582C11.4811 21.9583 10.4926 21.9583 9.68822 22.2023C7.87715 22.7517 6.45989 24.169 5.91051 25.98C5.6665 26.7844 5.6665 27.7729 5.6665 29.75M23.3748 10.625C23.3748 14.1458 20.5207 17 16.9998 17C13.479 17 10.6248 14.1458 10.6248 10.625C10.6248 7.10418 13.479 4.25 16.9998 4.25C20.5207 4.25 23.3748 7.10418 23.3748 10.625Z",
    stroke: "#667085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.af4f057a2fdb2e0f46264b008a03f0ef.svg";
export { ForwardRef as ReactComponent };